document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-main-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product gallery
  var main = document.getElementById('GalleryMain');
  var thumbs = document.querySelectorAll('.gallery-thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (main && thumb.dataset.fullSrc) {
        main.src = thumb.dataset.fullSrc;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      }
    });
  });
  if (thumbs.length && main) { thumbs[0].classList.add('active'); }
});
